<template>
    <v-row  class="room-activity-report-container-day-room">
        <v-col cols="6">
            <h2>Room - {{room.RoomText}}</h2>
        </v-col>
        <v-col cols="6" class="alive-in-room-container">
            <h3>Total Specimens: {{aliveInRoom}}</h3>
        </v-col>
        <v-col cols="12" class="alive-in-room-by-species-container">
            <v-data-table
                :headers="aliveInRoomBySpeciesHeaders"
                :items="aliveInRoomBySpeciesAsArray"
                hide-default-footer
            >
                <template  v-slot:items="props">
                    <tr>
                        <td v-for="(header, index) in aliveInRoomBySpeciesHeaders" :key="index" class="text-center">
                            {{props.item[header.value]}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12">
            <DailyHusbandryRoomActivityReportDayRoomUser
                v-for="(user) in includedUsersWithData"
                :key="user.Email"
                :user="user"
                :drawerData="drawerData[user.Email]"
                :observationAndOccurrenceData="observationAndOccurrenceData[user.Email] || {}"
                :extractionData="extractionData[user.Email]"
            >
            </DailyHusbandryRoomActivityReportDayRoomUser>
        </v-col>
    </v-row>
</template>

<script>
import DailyHusbandryRoomActivityReportDayRoomUser from "@/components/reporting/HusbandryRoomActivityReportDayRoomUser.vue";

export default {
    components: {
        DailyHusbandryRoomActivityReportDayRoomUser
    },
    props: [
        //eslint-disable-next-line
        "room",
        //eslint-disable-next-line
        "drawerData",
        //eslint-disable-next-line
        "observationAndOccurrenceData",
        //eslint-disable-next-line
        "aliveInRoom",
        //eslint-disable-next-line
        "aliveInRoomBySpeciesData",
        //eslint-disable-next-line
        "extractionData"
    ],
    data() {
        return {
            
        }
    },
    computed: {
        includedUsersWithData() {
            let includedUsers = [];

            const possibleExtraUsers = [
                ...this.drawerData.IncludedUsers || [],
                ...this.observationAndOccurrenceData.IncludedUsers || [],
                ...this.extractionData.IncludedUsers || []
            ];

            for (const newUser of possibleExtraUsers) {
                if (includedUsers.findIndex(r => r.Email == newUser.Email) < 0) {
                    includedUsers.push(newUser);
                }
            }

            return includedUsers;
        },
        aliveInRoomBySpeciesHeaders() {
            if (!this.aliveInRoomBySpeciesData || !this.aliveInRoomBySpeciesData.IncludedSpecies || this.aliveInRoomBySpeciesData.IncludedSpecies.length <= 0) {
                return [];
            }

            const headers = [];

            headers.push({
                text: "Total Specimens",
                value: "TotalSpecimens",
                sortable: false,
                align: "center"
            });

            for (let i=0; i<this.aliveInRoomBySpeciesData.IncludedSpecies.length; i++) {
                const header = this.aliveInRoomBySpeciesData.IncludedSpecies[i];

                headers.push({
                    text: header,
                    value: header,
                    sortable: false,
                    align: "center"
                });
            }

            return headers;
        },
        aliveInRoomBySpeciesAsArray() {
            const data = [];

            data.push(this.aliveInRoomBySpeciesData);
            data[0].TotalSpecimens = this.aliveInRoom;

            return data;
        }
    },
    methods: {
        
    },
    created() {
        
    }
}

</script>

<style lang="scss" scoped>

.alive-in-room-container {
    text-align: end;
}

</style>>